import React, { useEffect, useState } from "react";
import "./EditCohortModel.scss";
import { Modal } from "react-bootstrap";
import exportimages from "../../../../assets/images/exportImages";
import { useDispatch } from "react-redux";
import {
  createCohortSlice,
  editCohortSlice,
  setCohortApplied,
  setIsEditCohort,
  setIsFieldsEditiable,
  setMode,
  setSelectedCohort,
} from "../../../../rtk-query/features/cohort/cohortSlice";
import { HttpStatusCode } from "axios";
import { usePermissions } from "../../../../hooks/usePermissions";
import { useSubscription } from "../../../../hooks/useSubscription";
import { PRIVILEGES } from "../../../../utils/privileges";
import { COHORT_MODE } from "../CohortList/CohortList";

export const EDIT_MODEL = {
  EDIT: "edit",
  SUCCESS: "success",
};

export const EditCohortModel = (props) => {
  const dispatch = useDispatch();
  const { hasPermission } = usePermissions();
  const { hasSubscription } = useSubscription();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleEdit = async () => {
    try {
      setIsSubmitting(true);

      const data = await dispatch(
        editCohortSlice({
          cohortTitle: props.title,
          cohortDesc: props.subtitle,
          uid: props.uid,
        }),
      ).unwrap();

      props?.setSwitchEditModel(EDIT_MODEL.SUCCESS);
      dispatch(setMode(COHORT_MODE.CUSTOM));
      dispatch(setCohortApplied(null));
      dispatch(setSelectedCohort(data?.data));
      dispatch(setIsFieldsEditiable(false));
      dispatch(setIsEditCohort(false));
    } catch (err) {
      console.error("Edit cohort failed", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal {...props} animation aria-labelledby="contained-modal" centered>
      <Modal.Body className="cohort-modal">
        {props?.switchEditModel === EDIT_MODEL.EDIT ? (
          <div className="edit-cohort-modal">
            <div className="modal-header">
              <div className="icon-outer-circle">
                <div className="icon-inner-circle">
                  <img alt="icon" src={exportimages.edit_cohort_icon} />
                </div>
              </div>
            </div>

            <h2>Save Cohort Edits?</h2>
            <p className="subtitle">
              Your changes will update the filters and refresh the banks
              included in this cohort.
            </p>

            <div className="actions">
              <button className="btn cancel" onClick={() => props.onHide()}>
                Cancel
              </button>

              {hasPermission(PRIVILEGES.EDIT_COHORT) && (
                <button
                  className="btn primary"
                  onClick={handleEdit}
                  disabled={
                    !hasSubscription(PRIVILEGES.EDIT_COHORT)
                      ? true
                      : isSubmitting
                        ? true
                        : false
                  }
                >
                  {isSubmitting ? "Saving..." : "Save Edits"}
                </button>
              )}
            </div>
          </div>
        ) : (
          <div className="success-cohort-modal">
            <div className="modal-header">
              <div className="icon-outer-circle">
                <div className="icon-inner-circle">
                  <img alt="icon" src={exportimages.cohort_success_icon} />
                </div>
              </div>
            </div>

            <h2>Cohort Saved Successfully</h2>
            <p className="subtitle">
              Cohort <strong>{props.title}</strong> was saved successfully.
            </p>

            <div className="actions">
              <button className="btn cancel" onClick={() => props.onHide()}>
                Close
              </button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
